/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import FilterDropdown from '../FilterDropdown/Index'


export default function FilterDashboard({isFilterOpen,setIsFilterOpen,handleApplyFilter,handleClearFilter,initialState,filterValues,setFilterValues,handleOpenFilter,setIsAnyFieldFilled,  dateError,
    setdateError,data,isPatient,
}) {

    const reading_types = ['Blood Glucose', 'Blood Pressure', 'SPO2', 'Weight', 'Pulse', 'Temperature']
    const alert_types = ['Threshold Exceeding', 'Missed Reading']
    
    

    const toSnakeCase = (str) => {
        return str.replace(/\s+/g, '_').toLowerCase();
    };

    // checkbox selection
    const handleSelectAll = (selectAllChecked) => {
        setIsAnyFieldFilled !== undefined && setIsAnyFieldFilled(true);
        setFilterValues((prev) => {
            if (selectAllChecked) {
                // Add all elements to the array in snake_case
                const allReadingTypesInSnakeCase = reading_types.map(toSnakeCase);
                return {
                    ...prev,
                    reading_type: allReadingTypesInSnakeCase
                };
            } else {
                // Remove all elements from the array
                return {
                    ...prev,
                    reading_type: []
                };
            }
        });
    };
    
    const handleSelectAllAlert = (selectAllChecked) => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setFilterValues((prev) => {
            if (selectAllChecked) {
                // Add all elements to the array
                return {
                    ...prev,
                    alert_type: [...alert_types]
                };
            } else {
                // Remove all elements from the array
                return {
                    ...prev,
                    alert_type: []
                };
            }
        });
    };
    // clearall 
    const handleClear = () => {
        setFilterValues((prev) => ({
            ...prev,
            "reading_type": [],
        }));
    };
    const handleClearAlert = () => {
        setFilterValues((prev) => ({
            ...prev,
            "alert_type": [],
        }));
    };
    
    // reading type
    
    const handleReadingTypeSelect = (selectedItem) => {
        if (setIsAnyFieldFilled) setIsAnyFieldFilled(true);
    
        const snakeCaseSelectedItem = toSnakeCase(selectedItem);
    
        setFilterValues((prev) => {
            const isItemSelected = prev.reading_type.includes(snakeCaseSelectedItem);
    
            const updatedReadingType = isItemSelected
                ? prev.reading_type.filter(item => item !== snakeCaseSelectedItem)
                : [...prev.reading_type, snakeCaseSelectedItem];
    
            return {
                ...prev,
                reading_type: updatedReadingType
            };
        });
    };
    

    // const handleReadingTypeSelect = (selectedItem) => {
    //     setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
    //     setFilterValues((prev) => {
    //         // Check if the selected item is already in the array
    //         const isItemSelected = prev.reading_type.includes(selectedItem);
    //         // If the item is selected, remove it; otherwise, add it
    //         const updatedReadingType = isItemSelected
    //             ? prev.reading_type.filter(item => item !== selectedItem)
    //             : [...prev.reading_type, selectedItem];
    //         return {
    //             ...prev,
    //             reading_type: updatedReadingType
    //         };
    //     });
    // }
    const handleAlertTypeSelect = (selectedItem) => {
        setIsAnyFieldFilled!==undefined&&setIsAnyFieldFilled(true)
        setFilterValues((prev) => {
            // Check if the selected item is already in the array
            const isItemSelected = prev.alert_type.includes(selectedItem);
            // If the item is selected, remove it; otherwise, add it
            const updatedAlertType = isItemSelected
                ? prev.alert_type.filter(item => item !== selectedItem)
                : [...prev.alert_type, selectedItem];
            return {
                ...prev,
                alert_type: updatedAlertType
            };
        });
    }
    

    return (
        <div className='relative ml-2.5'>
            <button type='button' id='filter' className='flex mb-[14px] items-center border border-[#972E4C] rounded-[15px] px-4 py-2 min-w-max' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen && 
                // <motion.div
                //     initial={{ opacity: 0, x: 80,y:-46 }}
                //     animate={{ opacity: 1, x: 0 ,y:-46}}
                //     transition={{ delay: 0.2, duration: 0.5 }}
                //     exit={{ opacity: 0.5 }}
                //     className='z-[999] bg-white'
                // >
                    <div  className={`absolute top-14 lg:right-0  bg-white rounded-[15px] ${isPatient===undefined?(data?.data?.length===0 ? 'left-[-54px]':'left-[-340px]'):'left-[-344px]'}  border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[453px] z-[99]`}>
                        <div className={`${isPatient!==undefined?'px-1 h-[calc(100vh-516px)] overflow-x-hidden overflow-y-auto scrollbar_purple':''}`}>
                            <div className='flex justify-between items-center mb-4'>
                                <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                                <button type='button' onClick={()=>{setIsFilterOpen(!isFilterOpen),setFilterValues(initialState)}}>
                                    <img src="/images/cross_mark_gray.svg" alt="icon" />
                                </button>
                            </div>
                            
                            <div className='flex flex-wrap -mx-2'>
                                <div className='w-full px-2 mb-4'>
                                    <div className="w-full">
                                        <FilterDropdown
                                            label="Alert Type"
                                            id="alert_type"
                                            data_testid="select_all_alertType"
                                            placeholder={filterValues?.alert_type?.length === 0 ? "Select alert type" : `${filterValues?.alert_type?.length} selected`}
                                            disabled={false}
                                            options={alert_types}
                                            handleSelect={handleAlertTypeSelect}
                                            filterValues={filterValues}
                                            filterKey="alert_type"
                                            handleSelectAll={handleSelectAllAlert}
                                            handleClear={handleClearAlert}
                                        />
                                    </div>
                                </div>
                                <div className='w-full px-2 mb-4'>
                                    <div className="w-full">
                                        <FilterDropdown
                                            label="Reading Type"
                                            id="reading_type"
                                            data_testid="select_all"
                                            placeholder={filterValues.reading_type.length === 0 ? "Select reading type" : `${filterValues.reading_type.length} selected`}
                                            disabled={false}
                                            options={reading_types}
                                            handleSelect={handleReadingTypeSelect}
                                            filterValues={filterValues}
                                            filterKey="reading_type"
                                            handleSelectAll={handleSelectAll}
                                            handleClear={handleClear}
                                        />

                                    </div>
                                </div>
                                
                            </div>
                          
                            <div className="flex mt-[13px] justify-between">
                                <button  onClick={()=>{handleApplyFilter(false),handleClearFilter(),setFilterValues(initialState),setIsFilterOpen(false)}}
                                    id="Cancel"
                                    className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] mr-[38px]" 
                                >Clear All</button>
                                <button  
                                    onClick={()=>{
                                        
                                        handleApplyFilter(true),setIsFilterOpen(false)}}
                                    type='button'
                                    id="apply-filter"
                                    disabled={Object.values(filterValues).every(value => value === '' || (Array.isArray(value) && value.length === 0))} 
                                    className={`py-2.5 w-[106px] px-4 rounded-[16px]  ${Object.values(filterValues).every(value => value === '' || (Array.isArray(value) && value.length === 0))?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'}   text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                                    Apply
                                </button>
                               
                            </div>
                        </div>
                    </div>
               
                // </motion.div>
            }
        </div>  
    )
}
